<page-header title="MAP_ANALYTICS"></page-header>
<card>
  <div class="fields">
    <ng-select
      name="dashboard"
      [multiple]="false"
      [closeOnSelect]="true"
      (change)="onDashboardChange($event)"
      [placeholder]="'DASHBOARD' | translate"
      style="width: 250px"
      (clear)="onDashboardClear()"
      [translationEditableModalDirective]="dashboardsTranslateKeys"
      [translationEditableModalDirectiveDefaults]="dashboardsTranslateDefaults"
    >
      <ng-option *ngFor="let dashboard of dashboards" [value]="dashboard">
        {{ dashboard.trnKey | translate : { defaultValue: dashboard.title } }}
      </ng-option>
    </ng-select>
    <ng-select
      [name]="param.name"
      [multiple]="false"
      [closeOnSelect]="true"
      (change)="onParamChange(param.parameterName, $event)"
      [placeholder]="
        param.translationKey | translate : { defaultValue: param.title }
      "
      style="width: 250px"
      (clear)="onDashboardClear()"
      *ngFor="let param of dashboardParams"
    >
      <ng-option
        *ngFor="let option of paramOptions[param.name]"
        [value]="option"
      >
        {{ option.name }}
      </ng-option>
    </ng-select>
    <button
      [disabled]="
        !dashboard || dashboardParams.length !== paramOptionsLength || isLoading
      "
      class="button is-info"
      style="height: 40px"
      (click)="onSubmit()"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <analytics-map
    [isLoading]="isLoading"
    [selectedLayer]="selectedLayer"
    [data]="data"
  ></analytics-map>
</card>
